module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/201-martinique-ebe18cbc9f81a7a2d22073da01bbe9ba.svg";